import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// When an admin session expires, the backend returns 401 on /admin/* routes.
// Clear the stale token and bounce to the login page instead of dead-ending.
http.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    if ((status === 401 || status === 403) && url.includes("/admin/")) {
      localStorage.removeItem("bc_admin_token");
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.replace("/admin/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export const formatPrice = (n) =>
  "₹" + Number(n).toLocaleString("en-IN");

export const CATEGORIES = [
  { name: "Top Offers", icon: "Percent" },
  { name: "Statues", icon: "Landmark" },
  { name: "Home Decor", icon: "Lamp" },
  { name: "Pottery & Ceramics", icon: "Amphora" },
  { name: "Textiles", icon: "Shirt" },
  { name: "Wood Craft", icon: "TreePine" },
  { name: "Jewellery", icon: "Gem" },
  { name: "Wall Art", icon: "Frame" },
];

export const ADMIN_CATEGORIES = [
  "Statues", "Home Decor", "Pottery & Ceramics", "Textiles",
  "Wood Craft", "Jewellery", "Wall Art",
];

export const SIZES = ["Small", "Medium", "Large"];

export const SUBCATEGORY_IMAGES = {
  "Pooja": "https://customer-assets-v7afamib.emergentagent.net/job_flipkart-demo-4/artifacts/936fc0587ade7d0a_Warm%20Golden%20Ganesha%20Pooja%20Room%20%281%29.png",
  "Car Dashboard": "https://customer-assets-v7afamib.emergentagent.net/job_flipkart-demo-4/artifacts/6082c1a1813b8af9_Devotional%20Dashboard%20with%20Ganesha%20and%20Flags.png",
};

export const SUBCATEGORIES = {
  "Statues": ["Car Dashboard", "Pooja", "Living Room Statue", "Wall Hanging"],
  "Home Decor": ["Brass Idols", "Diyas & Urlis", "Showpieces", "Candle Holders"],
  "Pottery & Ceramics": ["Vases", "Pots & Planters", "Dinnerware", "Storage Jars"],
  "Textiles": ["Scarves & Dupattas", "Throws & Blankets", "Table Linen", "Sarees"],
  "Wood Craft": ["Sculptures", "Wall Decor", "Boxes & Storage", "Kitchenware"],
  "Jewellery": ["Earrings", "Necklaces", "Bangles & Bracelets", "Rings"],
  "Wall Art": ["Pichwai", "Madhubani", "Warli", "Miniature Art"],
};

const getVisitorId = () => {
  let v = localStorage.getItem("bc_vid");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("bc_vid", v);
  }
  return v;
};

export const trackEvent = (type, extra = {}) => {
  try {
    http
      .post("/analytics/event", { type, visitor_id: getVisitorId(), ...extra })
      .catch(() => {});
  } catch {
    /* analytics must never break the app */
  }
};
